import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  SignUp,
  Login,
  DashboardLayout,
  FaqPage,
  ProfilePage,
  InsiderStrategies,
  Lostinthehouse,
  Test,
  Lostinthesauce,
  Forgot,
  Verify,
  SectopScope,
  Day,
  Home,
  LifeofPI,
  Learn,
  SubscriptionsPage,
  TradingJournal,
  Intraday,
  DhanCon
} from "./screens";
import LogoutLayout from "./components/LogoutLayout";

// Import our new theme-aware components
import Support from "./screens/Support.jsx";
import FAQ from "./screens/FAQ.jsx";
import Subscriptions from "./screens/Subscriptions.jsx";

// Dynamic import for the About Us page
import {
  AboutUs,
  RefundPolicy,
  TermsOfService,
  PrivacyPolicy,
  Disclaimer,
  DisclosureOfMaterialInformation,
  // SEBICertificate,
} from "./screens/footerPages";

export const LoginNavs = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/Dashboard" element={<DashboardLayout />} />
      {/* <Route path="/StrategyConsole" element={<InsiderStrategies />} /> */}
      <Route path="/Sector" element={<SectopScope />} />
      <Route path="/Profile" element={<ProfilePage />} />
      <Route path="/Subscriptions" element={<SubscriptionsPage />} />
      <Route path="/Myday" element={<Day />} />
      <Route path="/Help" element={<Support variant="dashboard" />} />
      <Route path="/FAQ" element={<FaqPage />} />
      <Route path="/PiScanner" element={<LifeofPI />} />
      <Route path="/Learn" element={<Learn />} />
      <Route path="/Journal" element={<TradingJournal />} />
      <Route path="/Intraday" element={<Intraday />} />
      <Route path="*" element={<DashboardLayout />} />
      {/* <Route path="/test" element={<Test />} /> */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/AboutUs" element={<AboutUs />} />
    </Routes>
  );
};

export const LogoutNavs = () => {
  return (
    <Routes>
      <Route element={<LogoutLayout />}>
        <Route path="/forgotpass" element={<Forgot />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        {/* <Route path="/verify" element={<Verify />} /> */}
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route
          path="/disclosure"
          element={<DisclosureOfMaterialInformation />}
        />
        <Route
          path="/Subscriptions"
          element={<Subscriptions variant="marketing" />}
        />
        <Route path="/support" element={<Support variant="marketing" />} />
        <Route path="/faqs" element={<FAQ variant="marketing" />} />
        <Route path="/updates" element={<DhanCon />} />
        <Route path="*" element={<Home />} />
      </Route>
      {/* Keep Home and Signup outside the LogoutLayout since they have their own navbar and footer */}
      <Route path="/" element={<Home />} />
    </Routes>
  );
};
